"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var mercadoPagoContainerStyles_1 = require("./mercadoPagoContainerStyles");
var core_1 = require("@material-ui/core");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var MercadoPago = function () {
    var styles = mercadoPagoContainerStyles_1.default();
    var intl = react_intl_1.useIntl();
    return (<>
      <core_1.Typography variant="subtitle1" className={styles.title}>
        <Translation_1.default id="trans__checkout__payment_page__subtitle"/>
      </core_1.Typography>
      <core_1.Typography variant="subtitle2">
        <Translation_1.default className={styles.description} id="trans__checkout__payment_page__description1"/>
      </core_1.Typography>
      <core_1.Typography variant="subtitle1" className={styles.description2}>
        <Translation_1.default id="trans__checkout__payment_page__description2" values={{
        email: (<a className={styles.email} href={"mailto:" + intl.formatMessage({
            id: 'trans__checkout__payment_page__email',
        })}>
                <Translation_1.default id={'trans__checkout__payment_page__email'}/>
              </a>),
    }}/>
      </core_1.Typography>
    </>);
};
exports.default = MercadoPago;
